import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';
import mergers from 'seamless-immutable-mergers';

export const { Types, Creators } = createActions({
  loginRequest: ['user'],
  loginSuccess: ['data'],
  loginFailed: ['error'],

  registerRequest: ['user'],
  registerSuccess: ['register'],
  registerFailed: ['error'],

  rescuePasswordRequest: ['mail'],
  rescuePasswordSuccess: ['rescue'],
  rescuePasswordFailed: ['rescue'],

  changePasswordRequest: ['payload', 'token'],
  changePasswordSuccess: [],
  changePasswordFailed: ['error'],

  initialCustomerSuccess: ['data'],

  customerAddressRequest: ['payload', 'remove'],
  customerAddressSuccess: ['listAddresses'],
  customerAddressFailed: ['error'],

  customerInfosRequest: ['customerId', 'token', 'payload', 'changePassword'],
  customerInfosSuccess: ['data'],
  customerInfosFailed: ['error'],

  customerOrdersRequest: ['pagination', 'last'],
  customerOrdersSuccess: ['orders'],
  customerOrdersFailed: ['error'],

  customerOrderInfosRequest: ['order'],
  customerOrderInfoSuccess: ['order', 'info'],
  customerOrderInfosFailed: ['error'],
  customerOrderInfosLoaded: ['orderId'],

  customerOrderPaymentRequest: ['order'],
  customerOrderPaymentSuccess: ['items', 'orderId'],
  customerOrderPaymentFailed: ['items', 'orderId'],

  customerOrderFreightRequest: ['order'],
  customerOrderFreightSuccess: ['items', 'orderId'],
  customerOrderFreightFailed: ['items', 'orderId'],

  customerOrderAddressRequest: ['order'],
  customerOrderAddressSuccess: ['items', 'orderId'],
  customerOrderAddressFailed: ['items', 'orderId'],

  customerOrderProductsRequest: ['order'],
  customerOrderProductsSuccess: ['items', 'orderId'],
  customerOrderProductsFailed: ['items', 'orderId'],

  customerPhonesRequest: ['payload', 'remove'],
  customerPhonesSuccess: ['listPhones'],
  customerPhonesFailed: ['error'],

  customerMailsRequest: ['payload', 'remove'],
  customerMailsSuccess: ['listMails'],
  customerMailsFailed: ['error'],

  customerAddressCepRequest: ['cep'],
  customerAddressCepSuccess: ['data'],
  customerAddressCepFailed: ['error'],

  customerDocsEnumRequest: [],
  customerDocsEnumSuccess: ['data'],
  customerDocsEnumFailed: ['error'],

  customerDocRequest: ['document'],
  customerDocSuccess: ['data'],
  customerDocFailed: ['error'],
});

const INITIAL_STATE = Immutable({
  isLoading: false,
  error: {},
  newAddress: {},
  menu: [],
  listPhones: [],
  listAddresses: [],
  listMails: [],
  register: {},
  telephones: {},
  address: {},
  type: { pf: {}, pj: {} },
  account: {},
  orders: {},
  orderLoading: [],
  rescue: {},
  enumDocs: [],
  changeSuccess: null,
});

const customerRequest = (state = INITIAL_STATE) =>
  state.merge({ isLoading: true, error: {}, rescue: {}, changeSuccess: null });

const customerAddressCepRequest = (state = INITIAL_STATE) =>
  state.merge({ isLoading: true, error: {}, rescue: {}, newAddress: {} });

const customerSuccess = (state = INITIAL_STATE, { data }) => state.merge(data).set('isLoading', false);

const customerFailed = (state = INITIAL_STATE, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const customerOrderInfosRequest = (state = INITIAL_STATE, { order }) =>
  state.merge({ orderLoading: [order.id] }, { merger: mergers.concatArrayMerger });

const customerOrderInfoSuccess = (state = INITIAL_STATE, { order, info }) => {
  const index = state
    .getIn(['orders', 'items'])
    .findIndex((value) => value.id === order.id && value.hash === order.hash);

  return state
    .setIn(['orders', 'items', index], state.getIn(['orders', 'items', index]).merge(info))
    .merge({ isLoading: false });
};

const customerOrderInfosLoaded = (state = INITIAL_STATE, { orderId }) =>
  state.merge({
    orderLoading: state.getIn(['orderLoading']).filter((item) => item !== orderId),
  });

const customerAddressCepSuccess = (state = INITIAL_STATE, { data }) =>
  state.set('newAddress', data).set('isLoading', false);

const registerSuccess = (state = INITIAL_STATE, { register }) => state.merge({ register, isLoading: false });

const rescuePasswordSuccess = (state = INITIAL_STATE, { rescue }) => state.merge({ rescue, isLoading: false });

const rescuePasswordFailed = (state = INITIAL_STATE, { rescue }) => state.merge({ rescue, isLoading: false });

const loginSuccess = (state = INITIAL_STATE, { data }) =>
  state.merge({ isLoading: false, signedSuccess: true, ...data });

const customerAddressSuccess = (state = INITIAL_STATE, { listAddresses }) =>
  state.merge({ listAddresses, newAddress: {}, isLoading: false });

const customerPhonesSuccess = (state = INITIAL_STATE, { listPhones }) => state.merge({ listPhones, isLoading: false });

const customerMailsSuccess = (state = INITIAL_STATE, { listMails }) => state.merge({ listMails, isLoading: false });

const customerOrdersSuccess = (state = INITIAL_STATE, { orders }) => state.merge({ orders, isLoading: false });

const changePasswordSuccess = (state = INITIAL_STATE) => state.merge({ changeSuccess: true, isLoading: false });

const customerDocsEnumSuccess = (state = INITIAL_STATE, { data }) => state.merge({ enumDocs: data, isLoading: false });

const customerOrdersInfosFailed = (state = INITIAL_STATE, { items, orderId }) =>
  state
    .setIn(
      ['orders'],
      state.getIn(['orders']).merge(
        {
          items,
        },
        {
          merger: mergers.updatingByIdArrayMerger,
          mergerObjectIdentifier: 'id',
        }
      )
    )
    .merge({ isLoading: false, orderLoading: state.getIn(['orderLoading']).filter((item) => item !== orderId) });

export default createReducer(INITIAL_STATE, {
  [Types.LOGIN_REQUEST]: customerRequest,
  [Types.LOGIN_SUCCESS]: loginSuccess,
  [Types.LOGIN_FAILED]: customerFailed,

  [Types.REGISTER_REQUEST]: customerRequest,
  [Types.REGISTER_SUCCESS]: registerSuccess,
  [Types.REGISTER_FAILED]: customerFailed,

  [Types.RESCUE_PASSWORD_REQUEST]: customerRequest,
  [Types.RESCUE_PASSWORD_SUCCESS]: rescuePasswordSuccess,
  [Types.RESCUE_PASSWORD_FAILED]: rescuePasswordFailed,

  [Types.CHANGE_PASSWORD_REQUEST]: customerRequest,
  [Types.CHANGE_PASSWORD_SUCCESS]: changePasswordSuccess,
  [Types.CHANGE_PASSWORD_FAILED]: customerFailed,

  [Types.INITIAL_CUSTOMER_SUCCESS]: customerSuccess,

  [Types.CUSTOMER_INFOS_REQUEST]: customerRequest,
  [Types.CUSTOMER_INFOS_SUCCESS]: customerSuccess,
  [Types.CUSTOMER_INFOS_FAILED]: customerFailed,

  [Types.CUSTOMER_ORDERS_REQUEST]: customerRequest,
  [Types.CUSTOMER_ORDERS_SUCCESS]: customerOrdersSuccess,
  [Types.CUSTOMER_ORDERS_FAILED]: customerFailed,

  [Types.CUSTOMER_ORDER_INFOS_REQUEST]: customerOrderInfosRequest,
  [Types.CUSTOMER_ORDER_INFO_SUCCESS]: customerOrderInfoSuccess,
  [Types.CUSTOMER_ORDER_INFOS_FAILED]: customerFailed,
  [Types.CUSTOMER_ORDER_INFOS_LOADED]: customerOrderInfosLoaded,

  [Types.CUSTOMER_ORDER_PAYMENT_REQUEST]: customerOrderInfosRequest,
  [Types.CUSTOMER_ORDER_PAYMENT_SUCCESS]: customerOrderInfoSuccess,
  [Types.CUSTOMER_ORDER_PAYMENT_FAILED]: customerOrdersInfosFailed,

  [Types.CUSTOMER_ORDER_FREIGHT_REQUEST]: customerOrderInfosRequest,
  [Types.CUSTOMER_ORDER_FREIGHT_SUCCESS]: customerOrderInfoSuccess,
  [Types.CUSTOMER_ORDER_FREIGHT_FAILED]: customerOrdersInfosFailed,

  [Types.CUSTOMER_ORDER_ADDRESS_REQUEST]: customerOrderInfosRequest,
  [Types.CUSTOMER_ORDER_ADDRESS_SUCCESS]: customerOrderInfoSuccess,
  [Types.CUSTOMER_ORDER_ADDRESS_FAILED]: customerOrdersInfosFailed,

  [Types.CUSTOMER_ORDER_PRODUCTS_REQUEST]: customerOrderInfosRequest,
  [Types.CUSTOMER_ORDER_PRODUCTS_SUCCESS]: customerOrderInfoSuccess,
  [Types.CUSTOMER_ORDER_PRODUCTS_FAILED]: customerOrdersInfosFailed,

  [Types.CUSTOMER_PHONES_REQUEST]: customerRequest,
  [Types.CUSTOMER_PHONES_SUCCESS]: customerPhonesSuccess,
  [Types.CUSTOMER_PHONES_FAILED]: customerFailed,

  [Types.CUSTOMER_MAILS_REQUEST]: customerRequest,
  [Types.CUSTOMER_MAILS_SUCCESS]: customerMailsSuccess,
  [Types.CUSTOMER_MAILS_FAILED]: customerFailed,

  [Types.CUSTOMER_ADDRESS_REQUEST]: customerRequest,
  [Types.CUSTOMER_ADDRESS_SUCCESS]: customerAddressSuccess,
  [Types.CUSTOMER_ADDRESS_FAILED]: customerFailed,

  [Types.CUSTOMER_ADDRESS_CEP_REQUEST]: customerAddressCepRequest,
  [Types.CUSTOMER_ADDRESS_CEP_SUCCESS]: customerAddressCepSuccess,
  [Types.CUSTOMER_ADDRESS_CEP_FAILED]: customerFailed,

  [Types.CUSTOMER_DOCS_ENUM_REQUEST]: customerRequest,
  [Types.CUSTOMER_DOCS_ENUM_SUCCESS]: customerDocsEnumSuccess,
  [Types.CUSTOMER_DOCS_ENUM_FAILED]: customerFailed,

  [Types.CUSTOMER_DOC_REQUEST]: customerRequest,
  [Types.CUSTOMER_DOC_SUCCESS]: customerSuccess,
  [Types.CUSTOMER_DOC_FAILED]: customerFailed,
});
